<div class="modal-content">
	<form [formGroup]="form">
		<div class="modal-header">
			<h5 data-testid="SUBSYS2_UPGRADEMODAL_TITLE_TXT" class="modal-title">
				{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_TITLE }}
			</h5>
			<button type="button" class="hide-focus"></button>
		</div>
		<div class="modal-body">

			<div class="row">
				<div class="col">
					<span data-testid="SUBSYS2_UPGRADEMODAL_MESSAGE">{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_MESSAGE }}</span>
				</div>
			</div>

			<div class="row">
				<div class="col">
					<div class="form-group" style="width: fit-content;">
						<div class="custom-control custom-checkbox">
							<input data-testid="SUBSYS2_UPGRADEMODAL_TERMS_INPUT" type="checkbox" autocomplete="off"
								class="custom-control-input" id="Terms" formControlName="terms" />
							<label data-testid="SUBSYS2_UPGRADEMODAL_TERMS_LBL" class="custom-control-label" for="Terms">
								{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_TERMS }}
							</label>
						</div>
					</div>
				</div>
			</div>
			@if (isDeviceVisible) {
			<div class="row mt-4">
				<div class="col-12">
					<div class="form-group">
						<label for="device">{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_DEVICE }}</label>
						<select id="device" name="device" class="form-control custom-select w-25" formControlName="device"
							[class]="{'is-valid': form.controls.device.valid && form.controls.device.touched, 'is-invalid': form.controls.device.invalid && form.controls.device.touched}">
							<option [ngValue]="null">-</option>
							@for (device of deviceList(); track $index) {
							<option [value]="device">{{device}}</option>
							}
						</select>
						<div class="invalid-feedback">
							@if(form.controls.device.hasError('required')) {
							{{ labels().VALIDATION_MESSAGE_REQUIRED_DEVICE }}
							}
							@else if(form.controls.device.hasError('unsupportedModel')) {
							{{ labels().VALIDATION_MESSAGE_MIGRATE_UNSUPPORTED_MODEL }}
							}
						</div>
					</div>
				</div>
			</div>
			}

			<div class="row mt-4">
				<div class="col">
					<div class="form-group">
						<label data-testid="SUBSYS2_UPGRADEMODAL_NOTES_LBL" for="Notes">
							{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_NOTES }}
						</label>
						<input data-testid="SUBSYS2_UPGRADEMODAL_NOTES_INPUT" type="text" autocomplete="off" class="form-control"
							id="Notes" formControlName="notes" [placeholder]="labels().PLAN_UPGRADE_MODAL_COMPONENT_NOTES"
							[class]="{'is-valid': form.controls.notes.valid && form.controls.notes.touched, 'is-invalid': form.controls.notes.invalid && form.controls.notes.touched}" />
						<div class="invalid-feedback">
							@if(form.controls.notes.hasError('pattern')) {
							{{ labels().VALIDATION_MESSAGE_SPECIALCHARS_PLAN_NOTES | replace:SPECIAL_CHARS_LITE_TEXT }}
							}
							@else if(form.controls.notes.hasError('maxlength')) {
							{{ labels().VALIDATION_MESSAGE_MAXLENGTH_PLAN_NOTES | replace:NOTES_MAXLENGTH}}
							}
						</div>
					</div>
				</div>
			</div>

		</div>
		<div class="modal-footer">
			<button data-testid="SUBSYS2_UPGRADEMODAL_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				(click)="activeModal.dismiss()">
				{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_CANCEL_BUTTON }}
			</button>
			<button data-testid="SUBSYS2_UPGRADEMODAL_CONFIRM_BTN" type="button" class="btn btn-primary"
				[disabled]="!form.valid || isSaving" (click)="confirm()">
				{{ labels().PLAN_UPGRADE_MODAL_COMPONENT_CONFIRM_BUTTON }}
			</button>
		</div>
	</form>
</div>